export enum Icons {
  AccountCircle = 'account-circle',
  App = 'app',
  Apple = 'apple',
  ArrowCounterClockwise = 'arrow-counter-clockwise',
  ArrowDown = 'arrow-down',
  ArrowDownSLine = 'arrow-down-s-line',
  ArrowDropUp = 'arrow-drop-up',
  ArrowDropDown = 'arrow-drop-down',
  ArrowLeft = 'arrow-left',
  ArrowLeftLine = 'arrow-left-line',
  ArrowRight = 'arrow-right',
  ArrowRightLine = 'arrow-right-line',
  ArrowSquareOut = 'arrow-square-out',
  ArrowUp = 'arrow-up',
  Backspace = 'backspace',
  BellFill = 'bell-fill',
  Bell = 'bell',
  Bitcoin = 'bitcoin',
  BlueCheckMark = 'blue-check-mark',
  CalendarBlank = 'calendar-blank',
  CalendarEventFill = 'calendar-event-fill',
  CardholderFill = 'cardholder-fill',
  Cardholder = 'cardholder',
  CaretLeft = 'caret-left',
  CaretRight = 'caret-right',
  CaretUpDown = 'caret-up-down',
  CaretUp = 'caret-up',
  ChartBarFill = 'chart-bar-fill',
  ChartBar = 'chart-bar',
  ChartLineChart = 'chart-line-chart',
  Check = 'check',
  CheckFill = 'check-fill',
  CheckboxMultipleFill = 'checkbox-multiple-fill',
  CheckLine = 'check-line',
  Circle = 'circle',
  Close = 'close',
  CopySimple = 'copy-simple',
  CoinLine = 'coin-line',
  WeChatLine = 'we-chat-line',
  Dash = 'dash',
  Database = 'database',
  DefaultAccountImage = 'default-account-image',
  DeleteBin6Line = 'delete-bin-6-line',
  DeleteBin7Line = 'delete-bin-7-line',
  Discord = 'discord',
  DotsSixVertical = 'dots-six-vertical',
  DotsThreeOutline = 'dots-three-outline',
  Facebook = 'facebook',
  Fingerprint = 'fingerprint',
  Flag = 'flag',
  GiftFill = 'gift-fill',
  Gift = 'gift',
  GearSpinner = 'gear-spinner',
  GroupLine = 'group-line',
  Headset = 'headset',
  History = 'history',
  House = 'house',
  HouseSimpleFill = 'house-simple-fill',
  HouseSimple = 'house-simple',
  IdentificationCardFill = 'identification-card-fill',
  IdentificationCard = 'identification-card',
  Image = 'image',
  ImageFill = 'image-fill',
  Infinite = 'infinite',
  Info = 'info',
  InformationLine = 'information-line',
  Information2Line = 'information-2-line',
  Instagram = 'instagram',
  Ion = 'ion',
  Gear = 'gear',
  Key = 'key',
  Link = 'link',
  List = 'list',
  LockFill = 'lock-fill',
  LockLine = 'lock-line',
  Lock = 'lock',
  Logout = 'logout',
  MagnifyingGlass = 'magnifying-glass',
  MapPin = 'map-pin',
  Metamask = 'metamask',
  Minus = 'minus',
  Moon = 'moon',
  Menu = 'menu',
  MailLine = 'mail-line',
  Palette = 'palette',
  Pause = 'pause',
  Password = 'password',
  PencilSimpleLine = 'pencil-simple-line',
  Plus = 'plus',
  PulseFill = 'pulse-fill',
  PieChartLine = 'pie-chart-line',
  QrCode = 'qr-code',
  QrCodeLine = 'qr-code-line',
  QuestionFill = 'question-fill',
  Question = 'question',
  SealCheck1 = 'seal-check-1',
  SealCheck = 'seal-check',
  Share1 = 'share-1',
  EqualLine = 'equal-line',
  Share = 'share',
  ShieldCheck = 'shield-check',
  Shining2Line = 'shining-2-line',
  SlidersHorizontal = 'sliders-horizontal',
  StackSimpleFill = 'stack-simple-fill',
  StackSimple = 'stack-simple',
  StackFill = 'stack-fill',
  StarFill = 'star-fill',
  StarTwo = 'star-two',
  StarThree = 'star-three',
  StarFour = 'star-four',
  Star = 'star',
  SuitcaseSimpleFill = 'suitcase-simple-fill',
  SuitcaseSimple = 'suitcase-simple',
  Sun = 'sun',
  Swap = 'swap',
  Telegram = 'telegram',
  TelegramLine = 'telegram-line',
  ThumbsDown = 'thumbs-down',
  ThumbsUp = 'thumbs-up',
  TrashSimple = 'trash-simple',
  TrophyFill = 'trophy-fill',
  Trophy = 'trophy',
  Twitter = 'twitter',
  TwitterX = 'twitter-x',
  UserCircle = 'user-circle',
  UserFocus = 'user-focus',
  User = 'user',
  UserThree = 'user-three',
  UserPlus = 'user-plus',
  Users = 'users',
  UserFilled = 'user-filled',
  WalletFilled = 'wallet-filled',
  Wallet = 'wallet',
  Warning = 'warning',
  XCircle = 'x-circle',
  Points = 'points',
  Eye = 'eye',
  StarFillRounded = 'star-fill-rounded',
  Clover = 'clover',
  Leaf = 'leaf',
  IntersectingCircles = 'intersecting-circles',
  BlobBadge = 'blob-badge',
  HalfCircleBadge = 'half-circle-badge',
  ArrowUpCircleFill = 'arrow-up-circle-fill',
  ArrowDownCircleFill = 'arrow-down-circle-fill',
  SendOutlined = 'send-outlined',
  ArrowUpCircleLine = 'arrow-up-circle-line',
  ArrowDownCircleLine = 'arrow-down-circle-line',
  AbstractDecor = 'abstract-decor',
  LogoutCircleRLine = 'logout-circle-r-line',
  QuestionLine = 'question-line',
  ShieldLine = 'shield-line',
  Settings4Fill = 'settings-4-fill',
  MailAddLine = 'mail-add-line',
  Gmail = 'gmail',
  MailIos = 'mail-ios',
  More2Fill = 'more-2-fill',
  Outlook = 'outlook',
  Protonmail = 'protonmail',
  MailUnreadLine = 'mail-unread-line',
  MailCheckLine = 'mail-check-line',
  ShareForwardLine = 'share-forward-line',
  FileCopyLine = 'file-copy-line',
  StackLine = 'stack-line',
  User3Line = 'user-3-line',
  User3Fill = 'user-3-fill',
  TrophyLine = 'trophy-line',
  Settings4Line = 'settings-4-line',
  TwitterXFill = 'twitter-x-fill',
  TimerLine = 'timer-line',
  SubtractLine = 'subtract-line',
  AddLine = 'add-line',
  PassportLine = 'passport-line',
  Draggable = 'draggable',
  UploadCloudLine = 'upload-cloud-line',
  FileList2Line = 'file-list-2-line',
  Warpcast = 'warpcast',
  Chat1Line = 'chat-1-line',
  Rarimo = 'rarimo',
  Rarime = 'rarime',
  Restart = 'restart-line',
  ArrowLeftSLine = 'arrow-left-s-line',
  ArrowRightSLine = 'arrow-right-s-line',
  FlashLightFill = 'flashlight-fill',
  TimeLine = 'time-line',
  Usdc = 'usdc',
  Sketching = 'sketching',
  EditLine = 'edit-line',
  CloseFill = 'close-fill',
  DiscordLine = 'discord-line',
  FarcasterLine = 'farcaster-line',
  GooglePlay = 'google-play',
  CloseLine = 'close-line',
  TeamLine = 'team-line',
  TimeArrows = 'time-arrows',
  Robot2Line = 'robot-2-line',
  Flag2Line = 'flag-2-line',
  GiftLine = 'gift-line',
  VerifiedBadgeFill = 'verified-badge-fill',
  ArrowLeftRightLine = 'arrow-left-right-line',
  ArrowUpDownLine = 'arrow-up-down-line',
  ChatNewLine = 'chat-new-line',
  AddFill = 'add-fill',
  Ethereum = 'ethereum',
  ShareLine = 'share-line',
  DownloadLine = 'download-line',
  DraftLine = 'draft-line',
  CalendarLine = 'calendar-line',
  LoaderFill = 'loader-fill',
}
